export const getLocalStorageItem = (keyItem, defaultResult = null) => (localStorage[keyItem]
  ? JSON.parse(localStorage[keyItem])
  : defaultResult);
